import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { AssigneesModule } from "@webapp/assignees/assignees.module";
import { TopNavBarAvatarsConfig, TopNavBarVisibleAvatarsCount } from "@webapp/top-nav-bar/models/top-nav-bar.models";
import { UiAssigneeModule } from "@webapp/ui/assignee/assignee.module";
import { UiAvatarModule } from "@webapp/ui/avatar/avatar.module";
import { UiPopoverDirective } from "@webapp/ui/popover/popover.directive";

const MAX_NUMBER_OF_AVATARS = 5;

@Component({
  selector: "top-nav-bar-avatars",
  templateUrl: "./top-nav-bar-avatars.html",
  styleUrls: ["./top-nav-bar-avatars.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, UiAvatarModule, UiPopoverDirective, UiAssigneeModule, AssigneesModule],
  host: {
    "[attr.tabindex]": "0",
    "[attr.aria-label]": "config.a11yLabel",
  },
})
export class TopNavBarAvatarsComponent implements OnInit, OnChanges {
  @Input({ required: true }) public config: TopNavBarAvatarsConfig;
  @Input() public visibleAvatarsCount: TopNavBarVisibleAvatarsCount = TopNavBarVisibleAvatarsCount.ALL_AVATARS;

  public visibleAssignees = new Map<string, string>();
  public assigneesOnPopover = new Map<string, string>();
  public assigneesLimit = MAX_NUMBER_OF_AVATARS;

  public ngOnInit(): void {
    this.setAssigneesLimit(this.visibleAvatarsCount);
    this.setHiddenAndVisibleAssignees();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes?.visibleAvatarsCount && !changes?.visibleAvatarsCount.firstChange) {
      this.setAssigneesLimit(changes?.visibleAvatarsCount?.currentValue);
      this.setHiddenAndVisibleAssignees();
    }
  }

  private setHiddenAndVisibleAssignees(): void {
    const assigneesOnPopoverArr = Array.from(this.config.assigneesIdColorMap).slice(this.assigneesLimit);
    this.assigneesOnPopover = new Map(assigneesOnPopoverArr);
    const visibleCollaboratorsArr = Array.from(this.config.assigneesIdColorMap).slice(0, this.assigneesLimit);
    this.visibleAssignees = new Map(visibleCollaboratorsArr);
  }

  private setAssigneesLimit(currentVisibleAvatarsCount: number): void {
    /**
     * if up to 5 assignees => display them all (by default they are 5)
     * if more than 5 assignees on large screen => display 4 on first line + the rest in a counter
     * if more than 5 assignees on smaller screen => display 2 on first line + the rest in a counter
     */
    if (
      this.config.assigneesIdColorMap.size > MAX_NUMBER_OF_AVATARS ||
      (this.config.assigneesIdColorMap.size === MAX_NUMBER_OF_AVATARS && currentVisibleAvatarsCount !== TopNavBarVisibleAvatarsCount.ALL_AVATARS)
    ) {
      this.assigneesLimit = currentVisibleAvatarsCount - 1;
    } else {
      this.assigneesLimit = currentVisibleAvatarsCount;
    }
  }
}
